"use client";

import Drawer, {AnchorSide} from "../../Drawer";
import useModalAnimation from "../../useModalAnimation";
import {FCWithHTMLAttributes} from "@/app/types/reactTypes";
import useRouterEffect from "../../useRouterEffect";
import RACButton from "../../RACButton";
import clsMerge from "@/app/util/clsMerge";
import {useRef} from "react";
import LinkButton from "../../LinkButton";

export interface ContactPulloutClientWrapperProps {
	buttonContent: React.ReactNode;
	classes?: {
		triggerButton?: string;
	};
}

const ContactPulloutClientWrapper: FCWithHTMLAttributes<
	ContactPulloutClientWrapperProps
> = ({buttonContent, children, classes, id}) => {
	const drawerPortalRootRef = useRef<HTMLDivElement>(null);
	const [open, animationState, handlers] = useModalAnimation();
	useRouterEffect({onChange: handlers.closeModal});

	return (
		<div ref={drawerPortalRootRef}>
			<LinkButton
				href={"/contact-us"}
				className={clsMerge(
					"h-full",
					classes?.triggerButton,
					// Add hidden at all breakpoints >sm to ensure that
					//  the 2 buttons are never visible at the same time
					"md:hidden lg:hidden xl:hidden 2xl:hidden"
				)}
			>
				{buttonContent}
			</LinkButton>
			<RACButton
				id={id}
				onPress={handlers.openModal}
				className={clsMerge(
					"open-contact-sidebar-button",
					"h-full md:block",
					classes?.triggerButton,
					"hidden"
				)}
			>
				{buttonContent}
			</RACButton>
			<Drawer
				showCloseButton
				animationState={animationState}
				setAnimation={handlers.setAnimationState}
				anchorSide={AnchorSide.RIGHT}
				isOpen={open}
				onOpenChange={handlers.setIsOpen}
				UNSTABLE_portalContainer={drawerPortalRootRef.current ?? undefined}
			>
				{children}
			</Drawer>
		</div>
	);
};

export default ContactPulloutClientWrapper;
